/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractGetSchema } from "../../funcs/llmExtractGetSchema.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetExtractSchemaRequest$inboundSchema,
};

export const tool$llmExtractGetSchema: ToolDefinition<typeof args> = {
  name: "llm-extract-get-schema",
  description: `Get extraction schema by ID

Retrieve a stored extraction schema and its metadata.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractGetSchema(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
